module.exports = __webpack_public_path__ + "static/media/Artboard8.66a8ef02.png";